import { render } from "./CharacterEdit.vue?vue&type=template&id=85ea977e&scoped=true"
import script from "./CharacterEdit.vue?vue&type=script&lang=js"
export * from "./CharacterEdit.vue?vue&type=script&lang=js"

import "./CharacterEdit.vue?vue&type=style&index=0&id=85ea977e&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-85ea977e"

export default script